// Sections
require("section/img-text");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/block/img-text/index.js
 ** module id = 166
 ** module chunks = 0 1
 **/